import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { DonutChart } from '../../../common/ReusableComponent/Chart'; // Adjust the path as needed
import useApi from '../../../../utils/api-manager/Helper/useApi';

const InvoiceCard = () => {
  const { Post } = useApi();
  const currentYear = new Date().getFullYear();

  const [apiData, setApiData] = useState({
    dueInvoicePercentage: 0,
    creditInvoicePercentage: 0,
    discountPercentage: 0,
    profitPercentage: 0,
    soldQtyPercentage: 0,
  });

  const chartTitles = [
    'Due Invoice',
    'Credit Invoice',
    'Sales from Stock',
    'Profit Percentage',
    'Discount Given',
  ];

  const chartValues = [
    apiData.dueInvoicePercentage,
    apiData.creditInvoicePercentage,
    apiData.soldQtyPercentage,
    apiData.profitPercentage,
    apiData.discountPercentage,
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Post('salesAndExpenseReport', {
          start_date: `${currentYear}-01-01`,
          end_date: `${currentYear}-12-31`,
        });

        const {
          due_invoice,
          credit_invoice,
          discount_given,
          total_profit,
          product_inventory_statistic,
        } = response.data;

        setApiData({
          dueInvoicePercentage: due_invoice.due_invoice_percentage,
          creditInvoicePercentage: credit_invoice.credit_invoice_percentage,
          discountPercentage: discount_given.discount_percentage,
          profitPercentage: total_profit.profit_percentage,
          soldQtyPercentage: product_inventory_statistic.sold_qty_percentage,
        });
      } catch (error) {
        console.error('Error fetching the data:', error);
      }
    };

    fetchData();
  }, []);


  const isDataEmpty = chartValues.every(val => !val || val === 0);

  return (
    <Card.Body>
      {isDataEmpty ? (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <p style={{
          fontSize: '16px',
          color: '#999',
          textAlign: 'center',
          fontStyle: 'italic',
        }}>No data available.</p>
        </div>
      ) : (
        <div className="d-flex flex-wrap justify-content-between" style={{ gap: '10px' }}>
          {chartValues.map((value, idx) => (
            <div
              key={idx}
              style={{
                width: '130px',
                minWidth: '130px',
                height: '120px',
                position: 'relative',
                textAlign: 'center',
                marginBottom: '30px',
              }}
            >
              <DonutChart
                labels={['Active', 'Remaining']}
                datasets={[
                  {
                    data: [value, 100 - value],
                    backgroundColor: ['#36A2EB', 'rgba(211, 211, 211, 0.3)'],
                    hoverBackgroundColor: ['#36A2EB', 'rgba(211, 211, 211, 0.3)'],
                  },
                ]}
                height="140px"
                width="140px"
                legendPosition="none"
                theme="custom"
                noShadow
                noBorder
              />
              <div
                style={{
                  position: 'absolute',
                  top: '60%',
                  left: '55%',
                  transform: 'translate(-50%, -50%)',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#36A2EB',
                }}
              >
                {value.toFixed(0)}%
              </div>

              <div style={{ fontSize: '12px', marginTop: '-35px', fontWeight: '500', marginLeft: '15px' }}>
                {chartTitles[idx]}
              </div>
            </div>
          ))}
        </div>
      )}
    </Card.Body>
  );
};

export default InvoiceCard;
